export const maxSegmentCount = 6
